import React, { useState, useRef } from 'react';
import { withStyles } from '@material-ui/core/styles';
// import photoPlaceholder from '../../images/profile-placeholder.png';
// import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
// import Tooltip from '@material-ui/core/Tooltip';
// import IconButton from '@material-ui/core/IconButton';

import { setClassNameInDefns } from '../../common/definitionHelper';

import AfitdAvatarWithRing from '../../common/elemental/AfitdAvatarWithRing';
// import FileUploadDialog from './FileUploadDialog';

// import cx from 'clsx';
// import _get from 'lodash/get';

const styles = theme => ({
    root: {
        background: '#FAFAFC',
        width: '256px',
        height: '128px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    leftContainer: {
        // paddingLeft: '56px',
    },
    rightContainer: {
        // marginLeft: '12px',
        display: 'none',
    },

    KeyboardArrowLeftIcon: {
        fontSize: '20px',
        backgroundColor: '#F0F2F6',
        padding: '7px',
        borderRadius: '50%',
    },
});

// const allowedFileTypes = ['.png', '.jpg', '.jpeg'];

const getDefns = params => {
    const { props } = params;
    // const { selectedFile, fileInputRef } = params;
    // const { setSelectedFile } = params;
    const { classes, photoUrl } = props;

    // const fileUploadDialogOpen = !!selectedFile;

    const defns = {
        profilePic: {
            photoSize: 96,
            borderSize: 4,
            placeholderFontSize: 30,
            src: photoUrl,
        },
        // profilePhotoUploadButtonToolTip: {
        //     title: 'Upload Profile Picture',
        //     placement: 'top',
        //     arrow: true,
        // },
        // profilePhotoUploadButton: {
        //     component: 'label',
        //     // disabled: attachmentIconButtonDisabled,
        // },
        // selectFileInput: {
        //     type: 'file',
        //     style: { display: 'none' },
        //     onChange: handleChangeFile.bind(null, setSelectedFile),
        //     accept: allowedFileTypes.join(', '),
        // },
        // fileUploadDialog: {
        //     open: fileUploadDialogOpen,
        //     onClose: handleCloseFileUploadDialog.bind(null, setSelectedFile),
        //     onAttachmentUploadComplete: null, //handleCompleteAttachmentUpload.bind(null, onFileUploadComplete, clearReply, setIsRequestScrollToBottomRef),
        //     selectedFile,
        //     allowedFileTypes,
        //     // message,
        //     // // setMessage,
        //     // onMessageSend,
        //     // clearReply,
        //     fileInputRef,
        // },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

// const handleChangeFile = (setSelectedFile, evt) => {
//     const selectedFile = _get(evt, 'target.files[0]');
//     setSelectedFile(selectedFile);
// };

// const handleCloseFileUploadDialog = setSelectedFile => {
//     setSelectedFile(null);
// };

const PhotoSection = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    const fileInputRef = useRef();
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    const [selectedFile, setSelectedFile] = useState();
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({ props, selectedFile, setSelectedFile, fileInputRef });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return (
        <div {...defns.root}>
            <div {...defns.leftContainer}>
                <AfitdAvatarWithRing {...defns.profilePic} />
            </div>
            {/* <div {...defns.rightContainer}>
                <Tooltip {...defns.profilePhotoUploadButtonToolTip}>
                    <IconButton {...defns.profilePhotoUploadButton}>
                        <KeyboardArrowLeftIcon {...defns.KeyboardArrowLeftIcon} />
                        <input {...defns.selectFileInput} ref={fileInputRef} />
                    </IconButton>
                </Tooltip>
            </div> */}
            {/* <FileUploadDialog {...defns.fileUploadDialog} /> */}
        </div>
    );
    //---------------------------------------------------------------------
};

export default withStyles(styles)(PhotoSection);
